import React from 'react';
import styled from 'styled-components';
import { Button, Tooltip } from 'antd';
import { CodeOutlined } from '@ant-design/icons';

import RetentionComplexQueryExposureModal from '../../containers/retention/complex/RetentionQueryExposureModal';
import DocsLink from '../docs/DocsLink';
import docsBookmarks from '../../constants/docs';

const StyledRetentionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;

  .title {
    margin: 0;
  }
`;

const StyledButton = styled(Button)`
  border: none;
  background-color: transparent;
  margin-left: 10px;
`;

const RetentionComplexHeader = () => {
  const renderButton = (onClick, retentionEvents) => (
    <Tooltip placement="top" title="Expose a query">
      <StyledButton
        icon={<CodeOutlined />}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick();
          e.target.blur();
        }}
        disabled={!retentionEvents.every((i) => !!i)}
      />
    </Tooltip>
  );

  return (
    <StyledRetentionHeader>
      <h2 className="title">Retention</h2>
      <RetentionComplexQueryExposureModal button={renderButton} />
      <DocsLink
        scrolTo={docsBookmarks.retentionComplex}
        styleIcon={{ fontSize: 20, margin: 5, color: 'gray' }}
      />
    </StyledRetentionHeader>
  );
};

export default RetentionComplexHeader;
